import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Button, Panel, Separator, Text } from "@nju/ui";

interface IMySimCardRoamingBannerProps {
  isGlobalRoamingActive: boolean;
  isResignation14DaysAllowed: boolean | undefined;
}

export function SimCardRoamingBanner({
  isGlobalRoamingActive,
  isResignation14DaysAllowed,
}: IMySimCardRoamingBannerProps) {
  const blockServiceContent =
    "Zasady korzystania z usług nju subskrypcja zostały naruszone. Zgodnie z regulaminem ograniczyliśmy działanie usługi na Twoim numerze. Płatność będzie pobierana, dopóki nie zrezygnujesz z usługi. W razie pytań skontaktuj się z nami na czacie.";
  const blockRoamingContent =
    "W związku z naruszeniem regulaminu Twoje usługi roamingowe zostały zablokowane.\n W razie pytań skontaktuj się z nami na czacie.";

  return (
    <Panel>
      <div className="flex items-center gap-3">
        <Icon
          className="w-5 h-5 from-tablet:w-6 from-tablet:h-6"
          name="exclamation-circle"
          tone="accent"
        />
        <div className="flex flex-col">
          <Text
            size={{
              "@onlyMobile": "m",
              "@fromTablet": "xl",
            }}
            weight="bold"
          >
            blokada {isGlobalRoamingActive ? "usług" : "roamingu"}
          </Text>
        </div>
      </div>
      <Separator size="s" />
      <BlockText
        align="left"
        className="whitespace-pre-line"
        size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
      >
        {isGlobalRoamingActive ? blockServiceContent : blockRoamingContent}
      </BlockText>
      <Separator size="xs" tone="invisible" />
      <div className="flex justify-start gap-4">
        {isResignation14DaysAllowed && (
          <Link
            href={portalRoutes.mojeKonto.mojeUslugi.zrezygnujZUslugi.get({
              mode: "mobile",
            })}
            passHref={true}
          >
            <A size={{ "@onlyMobile": "s" }} variant="secondary">
              zrezygnuj z usługi
            </A>
          </Link>
        )}
        <Button
          onPress={() => {
            if ("closer" in window) {
              // @ts-expect-error missing types
              closer.openWidget();
            }
          }}
        >
          przejdź do czatu
        </Button>
      </div>
    </Panel>
  );
}
